module.exports = PlayerCdn;


//////////////////
// WEBPACK FOOTER
// external "PlayerCdn"
// module id = 55
// module chunks = 1